module.exports = __webpack_public_path__ + "img/image (4).f2f941f2.png";